import store from '@/store'
import Cookies from 'js-cookie'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

/**
 * 动态修改标题
 */
export function useDynamicTitle() {
  var title = Cookies.get("softname");
  if (store.state.settings.dynamicTitle) {
    document.title = store.state.settings.title + ' - ' + title;
  } else {
    document.title = title;
  }
}

/**
 * 动态返回图片路径
 */
export function useImageUrl(imgUrl) {
  var url = imgUrl;
  if (imgUrl == null || imgUrl == "") {
    url = defaultImgs.defaultImg;
  } else if (imgUrl != null && imgUrl.indexOf('http') == -1) {
    if (imgUrl.indexOf('/') == 0) {
      url = defaultSettings.fileUrl + imgUrl;
    } else {
      url = defaultSettings.fileUrl + '/' + imgUrl;
    }
  }
  return url;
}

/**
 * 动态返回图片路径
 * 解决403图片缓存问题
 */
export function getImageUrl(imgUrl) {
  if (imgUrl !== undefined) {
    let _u = imgUrl.substring(7);
    return 'https://images.weserv.nl/?url=' + _u;
  }
}

// 对象转成指定字符串分隔
export function listToString(list, separator) {
  let strs = "";
  separator = separator || ",";
  for (let i in list) {
    strs += useImageUrl(list[i].url) + separator;
  }
  return strs != "" ? strs.substring(0, strs.length - 1) : "";
}
// 对象转成指定字符串分隔(备份)
export function listToStringback(list, separator) {
  let strs = "";
  separator = separator || ",";
  for (let i in list) {
    strs += list[i].url.replace(defaultSettings.fileUrl, "") + separator;
  }
  return strs != "" ? strs.substring(0, strs.length - 1) : "";
}
//下载文件调用
export function downloadFile(resUrl, fileName) {
  if (!resUrl) {
    return
  }
  // 创建下载链接
  var url = "";
  var hostUrl = defaultSettings.hostUrl
  if (resUrl.indexOf('/') == 0) {
    url = hostUrl + resUrl;
  } else {
    url = hostUrl + '/' + resUrl;
  }
  var link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)// 文件名
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) // 下载完成移除元素
  window.URL.revokeObjectURL(url) // 释放掉blob对象
}
//计算高度
export function calcHeight(elementHeight, diffHeight) {
  // 改变窗口大小时需要做的处理
  // document.body.clientHeight // body区域内被内容撑开的距离 如果没有文档这个高度就是0
  // document.documentElement.clientHeight // 显示的是文档的区域，即使没有内容也有高度， 属于文档对象模型
  // window.innerHeight // 显示的是文档的区域，即使没有内容也有高度， 属于BOM（浏览器对象模型） 
  // 监听窗口大小变化
  //window.onresize = () => { };

  //50(nav) + 34(tags) + 15*2(app-container padding) +6 (line)  + 40(tab) + 60(footer)
  //默认扣除120
  //开启tagsView需要扣除
  let needTagsView = store.state.settings.tagsView;
  let defaultHeight = 50 + 15 * 2 + 6;
  if (needTagsView) {
    defaultHeight += 34;
  }
  let height = window.innerHeight;
  let curHeight = height - defaultHeight - diffHeight;
  if (curHeight <= 0) {
    curHeight = 100;
  }
  elementHeight.value = curHeight;
  //console.log('height:' + height + '--diffHeight:' + diffHeight);
}
//添加监听窗口大小变化事件
export function addResizeEvent(callback) {
  window.addEventListener("resize", callback);
}
//移出监听窗口大小变化事件
export function delResizeEvent(callback) {
  window.removeEventListener("resize", callback);
}
